import Loading from "components/loading";

export default function LoadingProcedure() {
    return (
        <div className="loading-procedure__container">
        <Loading/>
        <p>Recuperando el trámite...</p>
        </div>

    )
}